import React from 'react';
import { useTranslations } from 'next-intl';

import { blokTestConst } from 'modules/blok-test';
import { IMyResult } from 'modules/mavzuli-test';

import { Visible } from 'components';

interface IProps {
  myResults?: IMyResult;
  lessonName?: string;
}

const PassingScoreSection: React.FC<IProps> = ({ myResults, lessonName }) => {
  const t = useTranslations();

  return (
    <Visible
      if={myResults?.type === blokTestConst.testTypes.TOPIC_TEST}
      else={
        <Visible
          if={
            myResults?.type === blokTestConst.testTypes.VIRTUAL_TEST ||
            myResults?.type === blokTestConst.testTypes.DTM_TEST
          }
          else={
            <div className="h-full flex items-center justify-between rounded-xl bg-gray-100 p-1">
              <div className="flex w-full flex-col border-r-2 border-gray-300 text-center">
                <div className="flex items-center justify-center gap-1">
                  <p className="font-medium text-orange-400">{myResults?.direction?.passing_ball}</p>
                </div>
                <p className="text-xs text-gray-400">{t('otish_bali')}</p>
              </div>

              <div className="flex w-full flex-col text-center">
                <div className="flex items-center justify-center gap-1">
                  <p className="font-medium text-red-700">{myResults?.ball}</p>
                </div>
                <p className="text-xs text-gray-400">{t('toplangan_bal')}</p>
              </div>
            </div>
          }
        >
          <div className="h-full flex items-center justify-between rounded-xl bg-gray-100 p-1">
            <div className="flex w-full flex-col text-center">
              <div className="flex items-center justify-center gap-1">
                <p className="font-medium text-yellow-400">{myResults?.ball}</p>
              </div>
              <p className="text-xs text-gray-400">{t('toplangan_bal')}</p>
            </div>
          </div>
        </Visible>
      }
    >
      <div className="h-full rounded-xl bg-gray-100 p-3 text-sm font-medium">{lessonName}</div>
    </Visible>
  );
};

export default PassingScoreSection;
